if(!customElements.get('custom-featured-collection')){
    class CustomFeaturedCollection extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.navigations = this.querySelectorAll('.featured-collection__navigation');
            this.productList = this.querySelectorAll('.featured-collection__products');
            this.content = this.querySelector('.featured-collection__content');
            this.navigationWrapper = this.querySelector('.featured-collection__navigations');
            this.navigations.forEach(item => {
                item.addEventListener('click', this.switchProducts.bind(this));
                item.addEventListener("keydown", (event) => {
                    if(event.key === 'Enter'){
                        this.switchProducts(event);
                    }
                })
            })

            this.swiperContainers = this.querySelectorAll('.swiper-container');
            this.swiperContainers.forEach(item => {
                this.initSwiper(item);
            });

            this.collectionList = this.querySelector('.featured-collection-collection-list');
            this.ellipsisBtn = this.querySelector('.featured-collection__navigation-icon');
            this.ellipsisBtn.addEventListener('click', this.openCollectionList.bind(this));
            this.ellipsisBtn.addEventListener('keydown', (event) => {
                if(event.key === 'Enter'){
                    this.openCollectionList(event);
                }
            })

            this.adjustMinHeight();
            window.addEventListener('resize', this.adjustMinHeight.bind(this), false);
        }

        adjustMinHeight(){
            if(window.innerWidth > 1200){
                return;
            }

            var minHeight = 800;
            this.productList.forEach(item => {
                var clonedProductList = item.cloneNode(true);

                clonedProductList.style.height = 'auto';
                clonedProductList.classList.remove('h-100');
                minHeight = clonedProductList.offsetHeight > minHeight? clonedProductList.offsetHeight : minHeight;
            })

            this.content.style.minHeight = `${minHeight}px`;
            this.navigationWrapper.style.minHeight = `${minHeight}px`;
        }

        initSwiper(swiperContainer){
            var totalSlides = parseInt(swiperContainer.dataset.totalSlides);
            var numPerView = 4;
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
            var loop = (swiperContainer.dataset.loop == 'true')? true : false;
            if(totalSlides == 1) loop = false;


            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 20,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: 2 , spaceBetween: 15,
                    },
                    567: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    991: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    1200: {
                        slidesPerView: slidesPerView < 4? slidesPerView : 4
                    }
                },
                observer: true,
                observeSlideChildren: true
            }

            let productsWrapper = swiperContainer.closest('.featured-collection__products');
            if(productsWrapper.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: productsWrapper.querySelector('.swiper-pagination')
                }
            }

            
            if(productsWrapper.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: productsWrapper.querySelector('.swiper-button-next'),
                    prevEl: productsWrapper.querySelector('.swiper-button-prev')
                }
            }
        
            if(swiperContainer.dataset.autoplay == 'true'){
                let speed = swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }
        
            var swiper = new Swiper(swiperContainer, swiperSettings);
            this.getVisibleSlides(swiper);
            
            this.checkPagination(swiperContainer);
            this.updatePaginationWrapperMargin(productsWrapper);

            swiper.on('slideChange', () => {
                this.getVisibleSlides(swiper);
            });
            
            swiper.on('resize' ,() => {
                this.checkPagination(swiperContainer);
                this.updatePaginationWrapperMargin(productsWrapper);
            });
        }

        getVisibleSlides(swiper){
            if(swiper){
                const allSlides = swiper.slides;
                const activeIndex = swiper.activeIndex;
                const slidesPerView = swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        updatePaginationWrapperMargin(productsWrapper){
            let paginationWrapper = productsWrapper.querySelector('.swiper-pagination-wrapper');
            if(productsWrapper.querySelectorAll('.swiper-pagination-bullet').length > 1){
                paginationWrapper.classList.add('my-5')
            }else{
                paginationWrapper.classList.remove('my-5')
            }
        }

        checkPagination(item){
            var pagination = item.querySelector('.swiper-pagination');
            var btns = {
                prev: item.querySelector('.swiper-button-prev'),
                next: item.querySelector('.swiper-button-next')
            }

            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.style.display = 'none';
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.style.display = 'block';
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        switchProducts(e){
            const currentProductList = e.currentTarget;
            const currentProductListIdx = currentProductList.dataset.idx;

            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
            currentProductList.classList.add('active');

            this.productList.forEach(item => {
                var productListIdx = item.dataset.idx;

                if(productListIdx === currentProductListIdx){
                    item.setAttribute('data-active', 'true');
                    let swiperContainer = item.querySelector('.swiper-container');
                    this.initSwiper(swiperContainer); 
                }else{
                    item.setAttribute('data-active', 'false');
                }
            })

            this.updateActiveIndex(currentProductListIdx);
            this.closeCollectionList();
        }

        updateActiveIndex(idx){
            this.setAttribute('data-active-idx', idx);
        }

        openCollectionList(){
            this.collectionList.setAttribute('aria-hidden', 'false');
            this.querySelectorAll('.featured-collection__products').forEach(item => {
                item.style.visibility = 'hidden';
            })
            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
        }

        closeCollectionList(){
            this.collectionList.setAttribute('aria-hidden', 'true');
            this.querySelectorAll('.featured-collection__products').forEach(item => {
                item.style.visibility = 'initial';
            })
        }


        refresh(){
            this.init();
        }
    }

    customElements.define('custom-featured-collection', CustomFeaturedCollection);
}